import { createFileRoute } from "@tanstack/react-router";
import { listTasks } from "api-client";
import { capitalize } from "utils";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachLibraryTasksPage } from "src/pages/CoachLibraryTasksPage";
import { TASKS_DEFAULT_PAGE_SIZE } from "src/queries/tasks";

const searchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
});

export const Route = createFileRoute("/_auth/_coach/library/tasks/")({
  component: RouteComponent,
  validateSearch: searchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ deps }) {
    return await loaderHandler(async () => {
      const search = deps.q || "";
      const pageIndex = deps.p || 0;
      const pageSize = deps.ps || TASKS_DEFAULT_PAGE_SIZE;

      const tasks = await listTasks({
        query: {
          query: search || undefined,
          pageIndex,
          pageSize,
        },
      }).then((response) => {
        return response.data.data;
      });

      return {
        data: {
          tasks,
        },
      };
    });
  },
  staticData: {
    getBreadcrumb({ i18n }) {
      return {
        label: capitalize(i18n.t("tasks")),
        href: "/library/tasks",
      };
    },
  },
});

function RouteComponent() {
  return <CoachLibraryTasksPage />;
}
